module.exports = __webpack_public_path__ + "img/lesson_11.0bd31e89.jpg";